import { useState } from "react"

import { createFileRoute, redirect } from "@tanstack/react-router"

import { VerifyEmailCodeForm } from "@/components/account/VerifyEmailCodeForm"
import { EmbedLoginDialog } from "@/embed/components/account/EmbedLoginDialog"

type SignupCompleteSearch = {
  email: string
}

export const Route = createFileRoute("/embed/signup-complete")({
  validateSearch: (search): SignupCompleteSearch => ({
    email: typeof search.email === "string" ? search.email : "",
  }),
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { email } = Route.useSearch()
  const [loginOpen, setLoginOpen] = useState(false)

  return (
    <>
      <VerifyEmailCodeForm
        email={email}
        onAuthenticated={() => navigate({ to: "/" })}
        // Edge case: the code verified the email but no session was issued.
        // Fall back to the code sign-in dialog ("Confirm it's you").
        onSignInRequired={() => setLoginOpen(true)}
      />
      <EmbedLoginDialog
        open={loginOpen}
        onOpenChange={(open) => {
          if (!open) {
            setLoginOpen(false)
          }
        }}
        onSuccess={() => navigate({ to: "/" })}
      />
    </>
  )
}
